// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"496":"0aa5c3dd","825":"4a3c18b3","882":"54561222"}[chunkId] + ".chunk.js");